/* MAIN */
const attempt = (fn, fallback) => {
    try {
        return fn();
    }
    catch {
        return fallback;
    }
};
const castArray = (value) => {
    return isArray(value) ? value : [value];
};
const comparator = (a, b) => {
    if (a < b)
        return -1;
    if (a > b)
        return 1;
    return 0;
};
const decompose = (value) => {
    const components = [];
    for (let i = 0n; value > 0n; i += 1n, value >>= 1n) {
        if (value & 1n) {
            components.push(1n << i);
        }
    }
    return components;
};
const enumerate = (parts) => {
    if (parts.length === 0) {
        return [];
    }
    else if (parts.length === 1) {
        const part = parts[0];
        if (isArray(part)) {
            if (part.length <= 1) {
                return [part];
            }
            else {
                return part.map(value => [value]);
            }
        }
        else {
            return [[part]];
        }
    }
    const normalized = parts.map(castArray);
    const heads = normalized[0];
    const tails = enumerate(normalized.slice(1));
    const values = [];
    for (const head of heads) {
        if (tails.length) {
            for (const tail of tails) {
                values.push([head, ...tail]);
            }
        }
        else {
            values.push([head]);
        }
    }
    return values;
};
const first = (values) => {
    return values[0];
};
const isArray = (value) => {
    return Array.isArray(value);
};
const isKeyboardEvent = (value) => {
    return value instanceof KeyboardEvent;
};
const isMac = (() => {
    const isMac = (() => {
        if (typeof navigator === 'object') {
            return /mac|ipod|iphone|ipad/i.test(navigator.platform);
        }
        if (typeof globalThis['process'] === 'object') {
            return globalThis['process']['platform'] === 'darwin';
        }
        return false;
    })();
    return () => isMac;
})();
const isMouseEvent = (value) => {
    return value instanceof MouseEvent;
};
const isString = (value) => {
    return typeof value === 'string';
};
const isUndefined = (value) => {
    return value === undefined;
};
const last = (values) => {
    return values[values.length - 1];
};
const memoize = (fn) => {
    const cache = new Map();
    return (arg) => {
        const resultCached = cache.get(arg);
        if (!isUndefined(resultCached) || cache.has(arg))
            return resultCached;
        const result = fn(arg);
        cache.set(arg, result);
        return result;
    };
};
const nope = () => {
    return false;
};
const or = (values) => {
    return values.reduce((acc, value) => acc | value, 0n);
};
const orWith = (values, otherValues) => {
    return otherValues.map(other => {
        const head = values.slice(0, -1);
        const tail = last(values) || 0n;
        return [...head, tail | other];
    });
};
const take = (arr, nr) => {
    return arr.slice(0, Math.max(0, nr));
};
const takeRight = (arr, nr) => {
    return arr.slice(arr.length - Math.max(0, nr), arr.length);
};
const uniq = (values) => {
    if (values.length <= 1)
        return values;
    return Array.from(new Set(values));
};
const without = (values, except) => {
    if (!values.includes(except))
        return values;
    return values.filter(value => value !== except);
};
const yep = () => {
    return true;
};
/* EXPORT */
export { attempt, castArray, comparator, decompose, enumerate, first, isArray, isKeyboardEvent, isMac, isMouseEvent, isString, last, memoize, nope, or, orWith, take, takeRight, uniq, without, yep };
